import request from '../request';

import { IAccountOwnerPerspectiveToken } from './types';

export const getAccountOwnerPerspectiveToken = async (userId: number) => {
  const { data } = await request.post<IAccountOwnerPerspectiveToken>(
    `/account/login/view-only-token/`,
    {
      user_id: userId,
    },
  );

  return data;
};
